import React, { useState, useEffect, useContext } from 'react';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import { getGetRequestOptions } from "../components/GetToken";
import { AppContext } from '../context/AppContext';
import InputMask from 'react-input-mask';
import validationMessage from '../helpers/ValidationErrorMsg';

const customStylesSelect = {
    control: (provided) => ({
        ...provided,
        height: 'calc(1.35em + 1.1rem + 2px)',
        minHeight: '35px'
    }),
    valueContainer: (provided) => ({
        ...provided,
    })
};

const LogBookBreakDownHourEntry = () => {
    const { jwt } = useContext(AppContext);
    const [state, setState] = useState({
        logBookBusinessUnit: "",
        projectId: "",
        equipment: "",
        breakdownDate: "",
        hrs: "",
        mins: "",
        breakdownHour: "",
        hourMeterReading: "",
        allBusinessUnits: []
    });

    useEffect(() => {
        getAllBu();
    }, []);

    const getAllBu = () => {
        fetch(process.env.REACT_APP_API_URL + "get_user_business_units",
            getGetRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                let tempResp = resp.data.map(function (element) {
                    return { ...element, label: element.projectName, value: element.projectId, isdisabled: element.projectName === 'EMD' ? false : true }
                });
                setState(prev => ({ ...prev, allBusinessUnits: tempResp }));
            })
            .catch((error) => {
                console.log(error, "catch the hoop")
            });
    }

    const getEquipment = (inputValue, callback) => {
        if (!inputValue) {
            callback([]);
        } else {
            var url = process.env.REACT_APP_API_URL + "equipment/log_book_equipment_search/" + state.logBookBusinessUnit.projectId + "/" + state.breakdownDate + "?q=" + inputValue;

            setTimeout(() => {
                fetch(url, getGetRequestOptions())
                    .then((resp) => resp.json())
                    .then((resp) => {
                        const tempArray = resp.data.map(function (element) {
                            element.label = `${element.equipmentName} (${element.equipmentCode})`;
                            element.value = element.equipmentId;
                            return element;
                        });
                        callback(tempArray);
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop")
                    });
            });
        }
    }

    const handleEquipmentChange = equipment => {
        setState(prev => ({ ...prev, equipment: equipment }));
    }

    const handleBuChange = logBookBusinessUnit => {
        setState(prev => ({ ...prev, logBookBusinessUnit, projectId: logBookBusinessUnit.projectId }));
    }

    const handleInputOnChange = (name, value) => {
        setState(prev => ({ ...prev, [name]: value }));
    };

    const handleHourChange = (evt) => {
        const value = evt.target.value;
        if (value > 24) {
            return;
        }
        setState(prev => ({
            ...prev,
            hrs: value,
            breakdownHour: `${value}:${prev.mins || '00'}`
        }));
    }

    const handleMinuteChange = (evt) => {
        const value = evt.target.value;
        if (value > 59) {
            return;
        }
        setState(prev => ({
            ...prev,
            mins: value,
            breakdownHour: `${prev.hrs || '00'}:${value}`
        }));
    }

    const handleSubmit = evt => {
        evt.preventDefault();

        const formData = {
            projectId: state.logBookBusinessUnit.value,
            equipment: {
                equipmentId: state.equipment.value,
                equipmentName: state.equipment.equipmentName
            },
            breakdownDate: state.breakdownDate,
            breakdownHour: state.breakdownHour,
            hourMeterReading: parseFloat(state.hourMeterReading)
        };

        Swal.fire({
            title: 'Are you sure?',
            text: "You want to entry this breakdown hour!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwt.token },
                    body: JSON.stringify(formData)
                };

                fetch(process.env.REACT_APP_API_URL + "app_breakdown_entry_create", requestOptions)
                    .then((resp) => resp.json())
                    .then((resp) => {
                        if (resp.success === true) {
                            let successMsg = resp.successMessage;
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: successMsg,
                            })

                            setState({
                                logBookBusinessUnit: "",
                                projectId: "",
                                equipment: "",
                                breakdownDate: "",
                                hrs: "",
                                mins: "",
                                breakdownHour: "",
                                hourMeterReading: "",
                                allBusinessUnits: state.allBusinessUnits
                            });
                        } else {
                            const errorsMessage = validationMessage(resp.errorMessage).join("<br>");
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                html: errorsMessage,
                            })
                        }
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop");
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'An error occurred while submitting the form',
                        });
                    });
            }
        });
    }

    return (
        <>
            <div className="card card-custom">
                <div className="card-header">
                    <h3 className="card-title">
                        <p className="text-primary">
                            Breakdown Hour Entry
                        </p>
                    </h3>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="card-body">
                        <div className="ml-12">
                            <div className='row'>
                                <div className='col-12'>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-lg-2 col-form-label">Business Unit<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <Select
                                                value={state.logBookBusinessUnit}
                                                onChange={handleBuChange}
                                                options={state.allBusinessUnits}
                                                styles={customStylesSelect}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="breakdownDate" className="col-lg-2 col-form-label">Breakdown Date<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <input 
                                                type="date" 
                                                name="breakdownDate" 
                                                id="breakdownDate" 
                                                value={state.breakdownDate} 
                                                onChange={(e) => handleInputOnChange('breakdownDate', e.target.value)} 
                                                className={`form-control form-control-md`} 
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-lg-2 col-form-label">Equipment<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <AsyncSelect
                                                value={state.equipment}
                                                defaultOptions
                                                loadOptions={getEquipment}
                                                placeholder="Select Equipment"
                                                onChange={handleEquipmentChange}
                                                styles={customStylesSelect}
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group row">
                                        <label htmlFor="startingHrs" className="col-lg-2 col-form-label">Breakdown Hour<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <InputMask 
                                                    mask="99" 
                                                    className="form-control" 
                                                    name="hrs" 
                                                    id="hrs" 
                                                    placeholder="HH"
                                                    value={state.hrs}
                                                    onChange={handleHourChange}
                                                />
                                                <span className='input-group-text'>:</span>
                                                <InputMask 
                                                    mask="99" 
                                                    className="form-control" 
                                                    name="mins" 
                                                    id="mins" 
                                                    placeholder="MM"
                                                    value={state.mins}
                                                    onChange={handleMinuteChange}
                                                />
                                            </div>
                                            <small className="form-text text-muted">
                                                Enter hours (00-24) and minutes (00-59)
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="hourMeterReading" className="col-lg-2 col-form-label">Hrs Meter<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <input 
                                                type="number" 
                                                name="hourMeterReading" 
                                                id="hourMeterReading" 
                                                value={state.hourMeterReading} 
                                                onChange={(e) => handleInputOnChange('hourMeterReading', e.target.value)} 
                                                className={`form-control form-control-md`} 
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card-footer">
                        <div className="row">
                            <div className="col-4">
                            </div>
                            <div className="col-6">
                                <button type="submit" className="btn btn-success mr-2">Submit</button>
                                <button type="reset" className="btn btn-secondary">Cancel</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default LogBookBreakDownHourEntry;